"use client";
import { ButtonComponent } from "@/components";
import { Stack } from "@mui/material";
import { useTranslations } from "next-intl";
import React from "react";

const Languageswitch = () => {
  const changeLocale = (newLocale) => {
    if (typeof window !== "undefined") {
      window.location.pathname = `/${newLocale}${window.location.pathname.substring(
        3
      )}`;
    }
  };

  const t = useTranslations("Common");
  return (
    <Stack
      direction="row"
      alignItems={"center"}
      justifyContent={"end"}
      spacing={2}
      mt={2}
      mx={2}
    >
      {/* {typeof window !== "undefined" &&
      window.location.pathname.includes("en") ? (
        <>
          <ButtonComponent
            stackWidth={"auto"}
            buttonStyle={{
              width: "30%",
              minWidth: "70px",
              marginRight: "10px",
            }}
            onClick={() => changeLocale("hi")}
          >
            {t("hindi")}
          </ButtonComponent>
          {t("languageavailable")}
        </>
      ) : (
        <>
          {t("languageavailable")}
          <ButtonComponent
            stackWidth={"auto"}
            buttonStyle={{ width: "30%", minWidth: "70px", marginLeft: "10px" }}
            onClick={() => changeLocale("en")}
          >
            {t("english")}
          </ButtonComponent>
        </>
      )} */}
    </Stack>
  );
};

export default Languageswitch;
